import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateServiceAreaOverrideRule } from '../../../api/plan-service-area-override-rules-api'
import type {
  PlanServiceAreaOverrideRuleResponseDto,
  UpdatePlanServiceAreaOverrideRuleRequestDto,
} from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'
import { SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY } from './useGetServiceAreaOverrideRule'

export function useUpdateServiceAreaOverrideRule(id: string) {
  const queryClient = useQueryClient()

  return useMutation<
    PlanServiceAreaOverrideRuleResponseDto,
    unknown,
    UpdatePlanServiceAreaOverrideRuleRequestDto
  >({
    mutationFn: (body) => updateServiceAreaOverrideRule(id, body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY, id],
      })
    },
  })
}
